"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const qs_1 = require("qs");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const DeviceTransitionContainer_1 = require("../utils/DeviceTransitionContainer");
const OverviewModalHeader_1 = require("../wizards/overview/OverviewModalHeader");
const FormSection_1 = require("../utils/FormSection");
const Row_1 = require("../wizards/components/Row");
const InverseLabel_1 = require("../wizards/components/InverseLabel");
const reducers_1 = require("../../reducers");
const actions_1 = require("../../actions");
const getCampaignType_1 = require("../utils/getCampaignType");
const DateAndTime_1 = require("../wizards/ScheduledDelivery/DateAndTime");
const ScheduledDateAndTimeLabel_1 = require("./ScheduledDateAndTimeLabel");
const EditButton_1 = require("./EditButton");
const ScheduledSettingsForm_1 = require("./ScheduledSettingsForm");
const TapBehaviorLabel_1 = require("./TapBehaviorLabel");
const TapBehaviorContainer_1 = require("../wizards/notification/TapBehaviorContainer");
const MessageAndMedia_1 = require("../wizards/notification/MessageAndMedia");
const MessageAndMediaLabel_1 = require("./MessageAndMediaLabel");
const AlertOptionsLabel_1 = require("./AlertOptionsLabel");
const AlertOptionsContainer_1 = require("../wizards/notification/AlertOptionsContainer");
const AudienceLabel_1 = require("./AudienceLabel");
const Audience_1 = require("../wizards/Delivery/Audience");
const AdvancedSettingsContainer_1 = require("../wizards/notification/AdvancedSettingsContainer");
const SettingsExperiencePreview_1 = require("./SettingsExperiencePreview");
const FrequencyLimitLabel_1 = require("./FrequencyLimitLabel");
const FrequencyLimits_1 = require("../wizards/AutomatedDelivery/FrequencyLimits");
const CampaignDuration_1 = require("../wizards/AutomatedDelivery/CampaignDuration");
const CampaignDurationLabel_1 = require("./CampaignDurationLabel");
const EventTrigger_1 = require("../wizards/AutomatedDelivery/EventTrigger");
const APITrigger_1 = require("../wizards/APIDelivery/APITrigger");
const APITriggerPreview_1 = require("../wizards/APIDelivery/APITrigger/APITriggerPreview");
class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.getWizardSection = this.getWizardSection.bind(this);
        this.openSelectedWizard = this.openSelectedWizard.bind(this);
        this.getSaveAndClose = this.getSaveAndClose.bind(this);
        this.handleSelectedChange = this.handleSelectedChange.bind(this);
        this.campaignID = qs_1.parse(location.search.substring(1)).campaignId;
        props.createEditableCampaign(this.campaignID);
        props.getAllTags();
    }
    openSelectedWizard(wizard) {
        const { isCampaignFinished, openWizardModal } = this.props;
        if (!isCampaignFinished) {
            openWizardModal(wizard);
        }
    }
    getEditButton() {
        const { device, isCampaignFinished } = this.props;
        if (isCampaignFinished) {
            return;
        }
        return React.createElement(EditButton_1.default, { device: device });
    }
    getWizardSection() {
        const { currentWizard, device } = this.props;
        switch (currentWizard) {
            case 'dateAndTime':
                return React.createElement(DateAndTime_1.default, { device: device, wizardSection: "dateAndTime" });
            case 'audience':
                return React.createElement(Audience_1.default, { device: device, wizardSection: "audience" });
            case 'messageAndMedia':
                return React.createElement(MessageAndMedia_1.default, { device: device, wizardSection: "messageAndMedia", isCurrentPage: true });
            case 'alertOptions':
                return React.createElement(AlertOptionsContainer_1.default, { device: device, wizardSection: "alertOptions" });
            case 'tapBehavior':
                return (React.createElement(React.Fragment, null,
                    React.createElement(TapBehaviorContainer_1.default, { device: device, wizardSection: "tapBehavior" }),
                    device === 'Desktop' &&
                        ReactDOM.createPortal(React.createElement("div", { style: {
                                position: 'absolute',
                                top: 96,
                                left: 24,
                                textAlign: 'center',
                                width: 320,
                                height: 568,
                                background: 'white linear-gradient(rgba(233,233,233,1.0), rgba(238,238,238,0.5))',
                                zIndex: 10,
                            } }), document.getElementById('phone-bezel'))));
            case 'advancedSettings':
                return React.createElement(AdvancedSettingsContainer_1.default, { wizardSection: "advancedSettings", device: device });
            case 'frequencyLimits':
                return React.createElement(FrequencyLimits_1.default, { device: device, wizardSection: "frequencyLimits" });
            case 'campaignDuration':
                return React.createElement(CampaignDuration_1.default, { device: device, wizardSection: "campaignDuration" });
            case 'eventTrigger':
                return React.createElement(EventTrigger_1.default, { device: device, wizardSection: "eventTrigger" });
            case 'eventTrigger':
                return React.createElement(EventTrigger_1.default, { device: device, wizardSection: "eventTrigger" });
            case 'apiTrigger':
                return React.createElement(APITrigger_1.default, { device: device, wizardSection: "apiTrigger" });
            default:
                return null;
        }
    }
    getSaveAndClose() {
        const { currentWizard, updateTrigger, updateDeliverable } = this.props;
        switch (currentWizard) {
            case 'dateAndTime':
            case 'audience':
                return updateTrigger;
            case 'eventTrigger':
            case 'campaignDuration':
            case 'frequencyLimits':
                return updateTrigger;
            case 'messageAndMedia':
            case 'alertOptions':
            case 'tapBehavior':
            case 'advancedSettings':
                return updateDeliverable;
            case 'apiTrigger':
                return updateTrigger;
            default:
                return null;
        }
    }
    handleSelectedChange(newSelection) {
        this.props.updateCampaignTags(this.campaignID, newSelection);
    }
    render() {
        const { device, currentWizard, deliverable, trigger, segments, tagOptions, tags } = this.props;
        return (React.createElement(DeviceTransitionContainer_1.default, { device: device },
            React.createElement("div", { style: {
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'white',
                } },
                React.createElement(OverviewModalHeader_1.default, { campaignId: this.campaignID, device: device }),
                React.createElement("div", { style: {
                        height: '100%',
                        overflowY: 'scroll',
                        marginTop: 24,
                    } },
                    trigger && (React.createElement(FormSection_1.default, { device: device },
                        React.createElement(src_1.Text, { text: "Delivery", size: "h2", textStyle: { marginBottom: 8 } }),
                        getCampaignType_1.isScheduledCampaignTrigger(trigger) && (React.createElement(React.Fragment, null,
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('dateAndTime') },
                                React.createElement(InverseLabel_1.default, { title: "Date and Time" },
                                    React.createElement(ScheduledDateAndTimeLabel_1.default, { dateTime: trigger.dateTime })),
                                this.getEditButton()),
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('audience') },
                                React.createElement(InverseLabel_1.default, { title: "Audience" },
                                    React.createElement(AudienceLabel_1.default, { segments: segments, selectedSegment: trigger.segment })),
                                this.getEditButton()))),
                        getCampaignType_1.isAutomatedCampaignTrigger(trigger) && (React.createElement(React.Fragment, null,
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('eventTrigger') },
                                React.createElement(InverseLabel_1.default, { title: "Event Trigger" },
                                    React.createElement(src_1.Text, { size: "small", text: trigger.eventTrigger.eventName })),
                                this.getEditButton()),
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('campaignDuration') },
                                React.createElement(InverseLabel_1.default, { title: "Campaign Duration" },
                                    React.createElement(CampaignDurationLabel_1.default, null)),
                                this.getEditButton()),
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('audience') },
                                React.createElement(InverseLabel_1.default, { title: "Audience" },
                                    React.createElement(AudienceLabel_1.default, { segments: segments, selectedSegment: trigger.segment })),
                                this.getEditButton()),
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('frequencyLimits') },
                                React.createElement(InverseLabel_1.default, { title: "Frequency Limits" },
                                    React.createElement(FrequencyLimitLabel_1.default, { campaignId: this.campaignID })),
                                this.getEditButton()))),
                        getCampaignType_1.isAPICampaignTrigger(trigger) && (React.createElement(React.Fragment, null,
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('apiTrigger') },
                                React.createElement(InverseLabel_1.default, { title: "API Trigger" }),
                                this.getEditButton()),
                            React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('audience') },
                                React.createElement(InverseLabel_1.default, { title: "Audience" },
                                    React.createElement(AudienceLabel_1.default, { segments: segments, selectedSegment: trigger.segment })),
                                this.getEditButton()))))),
                    deliverable && getCampaignType_1.isNotificationCampaignDeliverable(deliverable) && (React.createElement(FormSection_1.default, { device: device },
                        React.createElement(src_1.Text, { text: "Notification", size: "h2", textStyle: { marginBottom: 8 } }),
                        React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('messageAndMedia') },
                            React.createElement(InverseLabel_1.default, { title: "Message and Media" },
                                React.createElement(MessageAndMediaLabel_1.default, { body: deliverable.body })),
                            React.createElement("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                } },
                                deliverable.attachment && deliverable.attachment.type === 'IMAGE' && (React.createElement("img", { src: deliverable.attachment.url, style: {
                                        height: 48,
                                        width: 48,
                                        borderRadius: 4,
                                        flex: 'none',
                                        marginRight: device !== 'Mobile' ? 16 : null,
                                    } })),
                                this.getEditButton())),
                        React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('alertOptions') },
                            React.createElement(InverseLabel_1.default, { title: "Alert Options" },
                                React.createElement(AlertOptionsLabel_1.default, { alertOptions: deliverable.alertOptions })),
                            this.getEditButton()),
                        React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('tapBehavior') },
                            React.createElement(InverseLabel_1.default, { title: "Tap Behavior" },
                                React.createElement(TapBehaviorLabel_1.default, { tapBehavior: deliverable.tapBehavior })),
                            this.getEditButton()),
                        React.createElement(Row_1.default, { onClick: () => this.openSelectedWizard('advancedSettings') },
                            React.createElement(InverseLabel_1.default, { title: "Advanced Settings" }),
                            this.getEditButton()))),
                    React.createElement(FormSection_1.default, { device: device },
                        React.createElement(src_1.Text, { text: "Tags", size: "h2", textStyle: { marginBottom: 8 } }),
                        React.createElement(src_1.MultiSelectInput, { selected: tags, options: tagOptions, onSelectedChange: this.handleSelectedChange }))),
                currentWizard &&
                    ReactDOM.createPortal(React.createElement(ScheduledSettingsForm_1.default, { device: device, campaignId: this.campaignID, saveAndClose: this.getSaveAndClose() }, this.getWizardSection()), document.getElementById('mainModalLeft')),
                device === 'Desktop' && document.getElementById('phone-bezel') && React.createElement(SettingsExperiencePreview_1.default, null),
                device === 'Desktop' &&
                    currentWizard === 'apiTrigger' &&
                    ReactDOM.createPortal(React.createElement(APITriggerPreview_1.default, null), document.getElementById('mainModalRight')))));
    }
}
const mapStateToProps = (state) => {
    const { campaignId } = qs_1.parse(location.search.substring(1));
    const campaign = reducers_1.getCampaign(state, campaignId);
    return {
        deliverable: campaign.deliverable,
        trigger: campaign.trigger,
        segments: reducers_1.getAllSegments(state),
        currentWizard: reducers_1.getCurrentWizard(state),
        isCampaignFinished: campaignId ? reducers_1.getIsCampaignFinished(state, campaignId) : false,
        tagOptions: reducers_1.getTags(state, ''),
        tags: campaign.tags,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        createEditableCampaign: (campaignId) => {
            dispatch(actions_1.createEditableCampaign(campaignId));
        },
        openWizardModal: (stateType) => dispatch(actions_1.openWizardModal(stateType)),
        updateTrigger: () => dispatch(actions_1.updateTrigger()),
        updateDeliverable: () => dispatch(actions_1.updateDeliverable()),
        getAllTags: () => dispatch(actions_1.getAllTags('')),
        updateCampaignTags: (id, tags) => dispatch(actions_1.updateTags(id, tags)),
    };
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Settings));
